<template lang="html">
	<div class="rs-stepper">
		<div class="buttons has-addons is-right">
			<button 
				class="button is-secondary" 
				:disabled="!canBeLower" 
				@click="change(-1)"><b>-</b></button>
			<div class="button">{{ value }}</div>
			<button 
				class="button is-secondary" 
				:disabled="!canBeHigher" 
				@click="change(1)"><b>+</b></button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Stepper',
	props: {
		value: Number,
		max: Number,
		min: Number
	},
	computed: {
		canBeHigher() {
			if (this.max === undefined) return true
			return this.value + 1 <= this.max
		},
		canBeLower() {
			if (this.min === undefined) return true
			return this.value - 1 >= this.min
		}
	},
	methods: {
		change(v) {
			const newValue = this.value + v
			this.$emit('input', newValue)
			this.$emit('update', newValue)
		}
	}
}
</script>

<style lang="css">
</style>
